<template>
  <div
    id="app"
    ref="main"
    class="app"
  >
    <main
      :key="$route.name"
      class="app-content"
    >
      <section
        v-if="action"
        class="app-nav"
      >
        <span
          :is="action"
          class="app-nav-items"
        />
      </section>

      <router-view
        ref="view"
        class="app-route"
      />
    </main>

    <portal-target
      name="popups"
      slim
    />

    <portal-target
      name="selects"
      slim
    />

    <transition-group
      appear
      class="app-toasts"
      name="fields"
      tag="ul"
    >
      <li
        v-for="toast in toasts.items"
        :key="toast.id"
        class="app-toast"
      >
        <context-toast
          :color="toast.color"
          @close="toasted(toast.id)"
        >
          {{ toast.message }}
        </context-toast>
      </li>
    </transition-group>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import ContextToast from '@cordel/components/Context/Toast.vue';

  const BREADCRUMBS = document.querySelector('.breadcrumbs');

  export default {
    name: 'App',
    components: {
      ContextToast,
    },
    data() {
      return {
        action: null,
      };
    },
    computed: {
      ...mapState([
        'toasts',
      ]),
    },
    watch: {
      $route: function route() {
        this.$nextTick(this.nav);
      },
    },
    mounted() {
      this.nav();
    },
    methods: {
      toasted(id) {
        this.$store.dispatch('toasts/destroy', id);
      },
      nav() {
        try {
          // eslint-disable-next-line prefer-destructuring, no-underscore-dangle
          this.action = this.$refs.view._data.nav.action;
        } catch (err) {
          this.action = null;
        }

        this.breadcrumbs();
      },
      breadcrumbs() {
        if (!BREADCRUMBS) {
          return;
        }

        const route = this.$route;

        if (route.meta && route.meta.breadcrumbless) {
          BREADCRUMBS.remove();

          return;
        }

        const { path } = route;

        const crumbs = [];
        const _crumbs = [];

        const routes = path.split('/').filter(i => i);
        const { length } = routes;

        document
          .querySelectorAll('.breadcrumbs li:not(.item-0)')
          .forEach(i => i.remove());

        let last;

        routes.forEach((_route, index) => {
          const li = document.createElement('li');
          const a = document.createElement('a');

          li.classList.add(`item-${index + 1}`);

          if (length === index + 1) {
            li.classList.add('last');
          }

          // eslint-disable-next-line no-underscore-dangle
          const _current = `/${routes.slice(0, index + 1).join('/')}`;
          const current = this.$router.resolve(_current);

          if (current.resolved.name === 'errors-404' || !(current.resolved.meta && current.resolved.meta.title)) {
            return;
          }

          let { title } = current.resolved.meta;

          if (title === 'Visualizar' && current.resolved.params && current.resolved.params.id && current.resolved.params.id !== last) {
            title = current.resolved.params.id;
          }

          if (title === last && title !== 'Visualizar') {
            title = 'Visualizar';
          }

          last = title;

          a.href = _current;
          a.innerText = title;

          li.append(a);

          crumbs.push(li);
          _crumbs.push(title);
        });

        BREADCRUMBS.append(...crumbs);
        document.title = _crumbs.length ? `${_crumbs.join(' › ')} - Credere` : 'Credere';
      },
    },
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/tokens.scss';
  @import '@cordel/assets/stylesheets/subtokens.scss';
  @import '@cordel/assets/stylesheets/transitions.scss';

  @import 'assets/stylesheets/_variables.scss';

  @import 'assets/stylesheets/base.scss';
  @import 'assets/stylesheets/proposals/status.scss';

  @import 'assets/stylesheets/transitions.scss';

  .app {
    position: relative;
  }

  .app-nav {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 0 var(--product--pwa--horizontal) var(--cordel-legacy-spacing-s);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal) var(--cordel-legacy-spacing-s);
    }
  }

  .app-nav-items {
    @media all and (max-width: $cordel-breakpoint-mobile) {
      flex: 1;
    }
  }

  .app-route {
    position: relative;
  }

  .app-content {
  }

  .app-toasts {
    bottom: var(--cordel-legacy-spacing-giga);
    left: 50%;
    list-style: none;
    max-width: calc(100% - var(--cordel-legacy-spacing-giga) * 2);
    position: fixed;
    transform: translateX(-50%);
    width: var(--cordel-legacy-spacing-popup);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      bottom: var(--cordel-legacy-spacing-s);
      max-width: calc(100% - var(--cordel-legacy-spacing-s) * 2);
    }
  }

  .app-toast {
    & + & {
      margin-top: var(--cordel-legacy-spacing-xxxs);
    }
  }
</style>
